import { Routes, Route, Navigate } from "react-router-dom";

import Login from "../pages/auth/Login";
// import Register from "../pages/auth/Register";
import EmailVerification from "../pages/auth/EmailVerification";

const AuthRoutes = () => {
  return (
    <Routes>
      <Route path="login" element={<Login />} />
      {/* <Route path="register" element={<Register />} /> */}
      <Route path="verify-email" element={<EmailVerification />} />

      <Route path="*" element={<Navigate to="/en/auth/login" replace />} />
    </Routes>
  );
};

export default AuthRoutes;
